// src/utils/tssSwimmingUtils.js

// Devuelve mensaje interpretativo del TSS
export const interpretTSS = (tssValue, language = 'es') => {
  const en = String(language || 'es').toLowerCase().startsWith('en');
  if (tssValue < 50)   return en ? "Recovery or very light training. Ideal for active rest days." : "Entrenamiento de recuperación o muy ligero. Ideal para días de descanso activo.";
  if (tssValue < 100)  return en ? "Sustainable effort, suitable for base sessions." : "Esfuerzo sostenible y adecuado para sesiones de base.";
  if (tssValue < 150)  return en ? "Moderate to intense training." : "Entrenamiento moderado a intenso.";
  if (tssValue < 200)  return en ? "Intense training, significant effort." : "Entrenamiento intenso, esfuerzo significativo.";
  if (tssValue >= 200) return en ? "Extremely intense training." : "Entrenamiento extremadamente intenso.";
  return en ? "Unrecognized TSS value. Verify input data." : "Valor de TSS no reconocido. Verifica los datos de entrada.";
};

// Función para calcular TSS solo si el deporte es natación
export const calculateSwimmingTSS = (data, language = 'es') => {
  const thresholdHeartRate = data?.ZonesTarget?.thresholdHeartRate ?? 170;

  // Aseguramos que session venga del primer elemento o como objeto plano
  const session = Array.isArray(data.sessions) ? data.sessions[0] : data.session;
  const avgHeartRate = session?.avg_heart_rate;
  const durationSeconds = session?.total_timer_time;
  const sport = session?.sport?.toLowerCase?.() || '';

  if (sport !== 'swimming' || !avgHeartRate || !durationSeconds) {
    return {
      tss: NaN,
      message: String(language || "es").toLowerCase().startsWith("en") ? "Insufficient data to calculate swimming TSS." : "Datos insuficientes para calcular TSS de natación."
    };
  }

  const durationHours = durationSeconds / 3600;
  const intensityFactor = avgHeartRate / thresholdHeartRate;
  const baseTSS = durationHours * intensityFactor * 100;
  const adjustedTSS = baseTSS * 0.6;

  const tss = adjustedTSS;
  const message = interpretTSS(tss, language);

  return {
    tss: tss.toFixed(2),
    message
  };
};

// Exportación adicional con el alias solicitado
export const calculateTSSWithTerrainSwimming = calculateSwimmingTSS;
